<span class="btn-container">
  <app-button
    (click)="csvExportFlights()"
    [black]="true"
    [title]="'resources.export_flights' | translate"
    class="flex-position-end btn-margin"
    header-button
    [disabled]="!this.data || this.data.length === 0"
  >
  </app-button
></span>

<qs-table
  testId="flight-history"
  [data]="data"
  [columns]="columns"
  [isPaginatorEnabled]="true"
  [paginatorConfig]="paginatorConfig"
></qs-table>

<ng-template #bodyTemplate let-row>
  <span *ngIf="row.configuration?.body" class="part-subtype">
    <span>
      {{ formatPartSubtype(row.configuration?.body?.partId?.partSubType) }}
    </span>
    <span>
      ({{ 'drone.flight_his.part_id' | translate }}:
      {{ row.configuration?.body?.partId.id }})
    </span></span
  >
</ng-template>
<ng-template #leftWingTemplate let-row>
  <span *ngIf="row.configuration?.leftWing" class="part-subtype">
    <span>
      {{ formatPartSubtype(row.configuration?.leftWing?.partId?.partSubType) }}
    </span>
    <span>
      ({{ 'drone.flight_his.part_id' | translate }}:
      {{ row.configuration?.leftWing?.partId.id }})
    </span></span
  >
</ng-template>
<ng-template #rightWingTemplate let-row>
  <span *ngIf="row.configuration?.rightWing" class="part-subtype">
    <span>
      {{ formatPartSubtype(row.configuration?.rightWing?.partId?.partSubType) }}
    </span>
    <span>
      ({{ 'drone.flight_his.part_id' | translate }}:
      {{ row.configuration?.rightWing?.partId.id }})
    </span></span
  >
</ng-template>
<ng-template #rearTemplate let-row>
  <span *ngIf="row.configuration?.rear" class="part-subtype">
    <span>
      {{ formatPartSubtype(row.configuration?.rear?.partId?.partSubType) }}
    </span>
    <span>
      ({{ 'drone.flight_his.part_id' | translate }}:
      {{ row.configuration?.rear?.partId.id }})
    </span></span
  >
</ng-template>
